import { AbstractEntity } from '@app/shared/abstract/abstract-entity';

/**
 * TVG-156: admin-only discount / adjustment line on an event finance.
 * A signed amount (positive adds, negative subtracts from the running balance)
 * with a free-text description, coded to a category.
 */
export interface EventAdjustmentModel extends AbstractEntity {
  event_id: number;
  description: string;
  amount: number;
  amount_formatted?: string;
  category: string;
  created_by_username?: string | null;
}

/**
 * Categories an adjustment line can be coded to. Mirrors the product catalogue
 * categories with a dedicated "Discount" entry. Kept in sync with
 * App\Models\EventAdjustment::CATEGORIES on the backend.
 */
export const EVENT_ADJUSTMENT_CATEGORIES: string[] = [
  'Discount',
  'Venue Hire',
  'Accommodation',
  'Wedding Morning Ideas – Food',
  'Wedding Morning Ideas – Drink',
  'Canapes',
  'Reception Drinks',
  'Wedding Breakfast Menus',
  'Drinks Packages',
  'Wine List',
  'Evening Food',
  'Evening Food – Complimentary',
  'Complimentary Items',
  'Extras – Food',
  'Extras – Drink',
  'DJ & Entertainment',
  'Hire Items',
  'Décor',
  'Floristry',
  'Miscellaneous',
  'Supplier Meals',
  'Security Retainer',
];
